import { render, staticRenderFns } from "./SixTable.vue?vue&type=template&id=4c8b79f6&"
import script from "./SixTable.vue?vue&type=script&lang=js&"
export * from "./SixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports